import React from 'react';

import Link from '@atlaskit/link';
import { Text } from '@atlaskit/primitives/compiled';

const RUNBOOK_URL =
	'https://hello.atlassian.net/wiki/spaces/~7120202da6a0b2c4184c0da3ba8ade6d08feaa/pages/5761728624/React+suspense+boundary+errors+run-book';

type QueryBoundaryErrorMessageProps = {
	operationName: string;
	errorType: 'outside-boundary' | 'boundary-mismatch';
	args?: {
		expectedBoundaries?: string[];
		currentBoundaries?: string[];
		boundaryName?: string;
	};
};

export const QueryBoundaryErrorMessage: React.FC<QueryBoundaryErrorMessageProps> = ({
	operationName,
	errorType,
	args,
}: QueryBoundaryErrorMessageProps) => {
	let message;
	switch (errorType) {
		case 'outside-boundary': {
			const expectedBoundaries = args?.expectedBoundaries?.join(', ') || '';
			message = `Query "${operationName}" preloaded in [${expectedBoundaries}] but accessed outside any suspense boundary.`;
			break;
		}
		case 'boundary-mismatch': {
			const expectedBoundaries = args?.expectedBoundaries?.join(', ') || '';
			const currentBoundaries = args?.currentBoundaries?.join(' → ') || '';
			message = `Query "${operationName}" preloaded in [${expectedBoundaries}] but accessed in "${currentBoundaries}" boundary.`;
			break;
		}
	}

	return (
		<div data-testid="queryBoundaryErrorMessage">
			<Text>{message}</Text>
			{(errorType === 'boundary-mismatch' || errorType === 'outside-boundary') && (
				<>
					{' '}
					See{' '}
					<Link target="_blank" href={RUNBOOK_URL}>
						this page
					</Link>{' '}
					for details.
				</>
			)}
		</div>
	);
};
